import { render, staticRenderFns } from "./hospitalMap.vue?vue&type=template&id=5c4b1e68"
import script from "./hospitalMap.vue?vue&type=script&lang=js"
export * from "./hospitalMap.vue?vue&type=script&lang=js"
import style0 from "./hospitalMap.vue?vue&type=style&index=0&id=5c4b1e68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports